import React from "react";

import { Link } from "react-router-dom";
import { Box } from "@mui/system";
import { Button, Typography } from "@mui/material";

export default function NeedAuth() {
    return (
        <Box
            maxWidth="md"
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                minHeight: "78vh",
                margin: "0 auto",
                width: '100%',
            }}
        >
            <Typography
                sx={{ width: "100%", textAlign: "center" }}
                variant="h1"
                component="h1"
            >
                No access.
            </Typography>
            <Typography
                sx={{ width: "100%", textAlign: "center" }}
                variant="h2"
                component="p"
            >
                To continue, you need to connect your wallet
            </Typography>
            <Button component={Link} to="/connect">Connect my wallet</Button>
        </Box>
    );
}
